import { GET_REACTIVATION_RESPONSE } from 'actions/restartCampaigns';

const defaultState = {
  data: {},
  isLoaded: false,
};

export default (state = defaultState, action) => {
  const { type, response } = action;

  switch (type) {
    case GET_REACTIVATION_RESPONSE:
      return {
        ...state,
        data: response.restartCampaign || {},
        isLoaded: true,
      };
    default:
      return state;
  }
};

export const selectRestartCampaign = state => state.restartCampaign.data;
export const selectRestartCampaignLoaded = state => state.restartCampaign.isLoaded;
